"use client";
import { useEffect } from 'react';
import { APP_ACTION_TYPES } from '@/store';
import { getDevices } from '@/utils/getDevice';

const usePlatform = (dispatch) => {
  const handleFunc = () => {
    const { device, platform } = getDevices();
    dispatch({
      type: APP_ACTION_TYPES.UPDATE_DEVICE,
      payload: { device },
    });
    dispatch({
      type: APP_ACTION_TYPES.UPDATE_PLATFORM,
      payload: { platform },
    });
  };

  useEffect(()=>{
    handleFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default usePlatform;
